import React from 'react';

const Error = (props) => {
  
  return (
    <div className='full-page'>
      <h1 className='text-center text-results'>
        Oops, something went wrong...
      </h1>
    </div>
  );
};

export default Error;
